import { render } from "./PaymentOptionsButton.vue?vue&type=template&id=63059a82&scoped=true"
import script from "./PaymentOptionsButton.vue?vue&type=script&lang=js"
export * from "./PaymentOptionsButton.vue?vue&type=script&lang=js"

import "./PaymentOptionsButton.vue?vue&type=style&index=0&id=63059a82&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63059a82"]])

export default __exports__